import React, { createContext, useEffect, useState } from 'react'
import IndexedDB from './IndexedDB'
import PropTypes from 'prop-types';
import schema from '../util/schema.json'
import IndexedDBAsync from './IndexedDBAsync';

export const IndexedDbContext = createContext()

function IndexedDbContextProvider({children}) {
    const [machinesIndexedDB] = useState(() => {
        const machinesScheme = new IndexedDB("dbV1", schema.schemas, 1)
        return machinesScheme
    }) 
    const [IndexedDBAsyncContext, setIndexedDBAsyncContext] = useState(null) 

    useEffect(() => {
        const db = new IndexedDBAsync("dbV1", schema.schemas, 1)
        db.openDB()
            .then(() => {setIndexedDBAsyncContext(db)})
    }, [])

    return IndexedDBAsyncContext && (
        <IndexedDbContext.Provider value={{machinesIndexedDB, IndexedDBAsyncContext}}>
            {children}
        </IndexedDbContext.Provider>
    )


}

IndexedDbContextProvider.prototype = {
    children: PropTypes.object
}

export default IndexedDbContextProvider

